export type UserRightFormat = { permission_id: string };
const userHasAtLeastOneRight = (rights: string[], userRights: UserRightFormat[]) => {
  for (let i = 0; i < rights.length; i += 1) {
    for (let j = 0; j < userRights.length; j += 1) {
      if (rights[i] === userRights[j]?.permission_id) {
        return true;
      }
    }
  }
  return false;
};

export default userHasAtLeastOneRight;
